import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Button,
  Box,
  useMediaQuery,
} from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { poppins300, poppins400, poppins500 } from 'theme/common.style';
import { Divider } from '@mui/material';
import { useTheme } from '@emotion/react';
import { postApiCall } from 'api/apiService';
import { CANCEL_FLOW, MOVETO_EXCHANGE } from 'constant/app.config';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useAgentBannerData } from 'Hooks/agent/useAgentBannerData';
export default function ExchangeStatusDialog({
  open,
  onClose,
  price,
  winner,
  propAddress,
  depositAmount,
  settlementDays,
  propertyId,
  buyerId,
  profileDetails,
  publishcard,
  unpublishcard,
  from,
  setOpenPublishWinnerBox,
  isIndividual,
  getListInfo,
}) {
  const [status, setStatus] = useState('');
  const [alternateWinner, setAlternateWinner] = useState(true);
  const theme = useTheme();
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const history = useHistory();

  const { getBannerData } = useAgentBannerData(propertyId);

  const buyerCount = isIndividual
    ? profileDetails?.PropertyDetails?.buyerTotalCount ?? 0
    : profileDetails?.buyerTotalCount ?? 0;

  useEffect(() => {
    if (buyerCount <= 1) {
      setAlternateWinner(false);
    }
  }, [buyerCount]);

  const isDepositCompleted =
    from === 'dashboard'
      ? profileDetails?.isWinnerDepositStatus === 'Completed'
      : profileDetails?.PropertyDetails?.isWinnerDepositStatus === 'Completed';

  const isBuyerContractSigned =
    from === 'dashboard'
      ? profileDetails?.isWinnerContractSignStatus === 'Completed'
      : profileDetails?.PropertyDetails?.isWinnerContractSignStatus ===
        'Completed';
  const isvendorContractSigned =
    from === 'dashboard'
      ? profileDetails?.vendorEsignStatus === 'Completed'
      : profileDetails?.PropertyDetails?.vendorEsignStatus === 'Completed';

  //to hit cancel exchange api and close exchange update popup
  const handleClose = async () => {
    if (
      !isvendorContractSigned ||
      !isBuyerContractSigned ||
      !isDepositCompleted
    ) {
      onClose();
      return;
    }

    const params = {
      propertyId: propertyId,
      buyerId: buyerId,
      action: 'Exchanged',
    };
    try {
      const res = await postApiCall(CANCEL_FLOW, params);
      if (res.data?.status == -1) {
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      } else {
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'success',
          confirmButtonText: 'Close',
        });
        if (isIndividual) {
          getBannerData();
        }
        if (typeof publishcard === 'function') {
          publishcard();
        }

        if (typeof unpublishcard === 'function') {
          unpublishcard();
        }
      }
    } catch (err) {
      console.error(err);
    }
    onClose();
  };

  const handleSubmit = async () => {
    if (alternateWinner) {
      if (from == 'dashboard') {
        history.push({
          pathname: `/dashboard/view-dashboard/${propertyId}`,
          state: { fromDashBoard: true },
        });
        return;
      }

      setOpenPublishWinnerBox(true);
      onClose();
      return;
    }

    const priceString = price;
    const priceInt = parseInt(priceString.replace(/[^0-9]/g, ''), 10);
    const numberValue = Number(depositAmount.replace(/[$,]/g, ''));
    const params = {
      propertyId: propertyId,
      buyerId: buyerId,
      price: priceInt,
      settlementDays: settlementDays,
      depositedPrice: numberValue,
      reasonForDelay: status,
      isExchange: 0,
      action: 'Exchanged',
    };
    try {
      const res = await postApiCall(MOVETO_EXCHANGE, params);
      if (res.data?.status != 1) {
        toast.error(res.data.message, {
          position: 'top-right',
          autoClose: 2000,
        });
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'error',
          confirmButtonText: 'Close',
          style: {
            fontFamily: 'Poppins',
          },
        });
      } else {
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'success',
          confirmButtonText: 'Close',
        }).then(() => {
          if (typeof publishcard === 'function') {
            publishcard();
          }

          if (typeof unpublishcard === 'function') {
            unpublishcard();
          }
        });
      }
    } catch (err) {
      console.error(err);
    }
    onClose();
  };

  const Pendingwarning = () => {
    return (
      <svg
        width="38"
        height="36"
        viewBox="0 0 38 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="37.5797"
          height="36"
          rx="18"
          fill="#F39800"
          fill-opacity="0.1"
        />
        <path
          d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
          fill="#F39800"
        />
      </svg>
    );
  };
  const ToggleOn = () => (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.460938"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="url(#paint0_linear)"
      />
      <ellipse
        cx="12.981"
        cy="12.1852"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="12.7341"
          y1="-1.66162"
          x2="18.2578"
          y2="28.3495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6C2AD2" />
          <stop offset="1" stopColor="#77CFFE" />
        </linearGradient>
      </defs>
    </svg>
  );

  const ToggleOff = () => (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.459961"
        y="0.370483"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="#DFDFDF"
      />
      <ellipse
        cx="30.0913"
        cy="12.5557"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
    </svg>
  );

  return (
    <>
      <Dialog
        open={open}
        // onClose={onClose}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            onClose();
          }
        }}
        maxWidth="sm"
        fullWidth
        fullScreen={matches450}
        PaperProps={{
          sx: {
            height: matches450 ? '500px' : 'auto',
          },
        }}
      >
        <DialogTitle>
          <Box>
            <Typography
              sx={{
                ...poppins400,
                fontSize: '14px',
                color: '#666666',
              }}
            >
              {propAddress}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1} mt={1}>
            <Pendingwarning />
            <Typography
              sx={{ ...poppins500, color: '#000000', fontSize: '24px' }}
            >
              Exchange Status Update
            </Typography>
          </Box>
          <Typography
            sx={{
              ...poppins400,
              fontSize: '16px',
              color: '#666666',
            }}
            mt={4}
          >
            Please update current exchange status.
          </Typography>
        </DialogTitle>
        <Divider sx={{ my: 2, mx: -3 }} />
        <DialogContent sx={{ pt: 2 }}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: '16px',
              color: '#666666',
            }}
            mb={1}
          >
            Status
          </Typography>
          <FormControl fullWidth size="small" sx={{ pl: 1, mt: 1 }}>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              displayEmpty
              IconComponent={KeyboardArrowDownRoundedIcon}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxWidth: matches450 ? '50px' : 'none',
                    width: 'auto',
                    '& .MuiList-root': {
                      maxHeight: 150,
                      overflowY: 'auto',
                    },
                    '& .MuiMenuItem-root': {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    },
                  },
                },
              }}
              sx={{
                ...poppins300,
                fontSize: '16px',
                color: status ? '#000' : '#666666', // Darken text only when selected
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                border: `1px solid ${status ? '#0055FFA3' : '#D9D9D9'}`,
                '& .MuiSelect-icon': {
                  fontSize: '1.4rem',
                  right: 10,
                },
              }}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <span style={{ color: '#666666' }}>
                      Select the reason for delay
                    </span>
                  );
                }
                return selected;
              }}
            >
              <MenuItem value="Vendor contract not signed">
                Vendor contract not signed
              </MenuItem>
              <MenuItem value="Buyer contract not signed">
                Buyer contract not signed
              </MenuItem>
              <MenuItem value="Deposit payment not yet received">
                Deposit payment not yet received
              </MenuItem>
              <MenuItem value="Vendor looking to rescind">
                {' '}
                Vendor looking to rescind
              </MenuItem>
              <MenuItem value="Buyer looking to rescind">
                Buyer looking to rescind
              </MenuItem>
              <MenuItem value="Other reason">Other reason</MenuItem>
            </Select>
          </FormControl>

          <Box mt={4}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: '16px',
                color: '#666666',
              }}
            >
              Would you like to nominate an alternate winner?
            </Typography>
            <Box
              mt={4}
              display="flex"
              alignItems="center"
              gap={2}
              onClick={() => {
                if (buyerCount >= 2) {
                  setAlternateWinner((prev) => !prev);
                }
              }}
              sx={{
                cursor: buyerCount >= 2 ? 'pointer' : 'not-allowed',
                pl: 2,
                opacity: buyerCount >= 2 ? 1 : 0.5,
                pointerEvents: buyerCount >= 2 ? 'auto' : 'none',
              }}
            >
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '12px',
                  color: '#666666',
                }}
              >
                Yes
              </Typography>
              {alternateWinner ? <ToggleOn /> : <ToggleOff />}
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '12px',
                  color: '#666666',
                }}
              >
                No
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#fff',
              borderRadius: '8px',
              borderColor: '#1123471A',
              textTransform: 'none',
              width: 100,
              color: '#666666',
              '&:hover': {
                bgcolor: '#fff',
                borderColor: '#1123471A',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#4CA4D6',
              borderRadius: '8px',
              textTransform: 'none',
              width: 100,
              '&:hover': {
                bgcolor: '#3293d0',
              },
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
